/**
 * User: hella
 * Date: 3/30/14
 * Time: 1:38 PM
 * Copyright 1stdibs.com, Inc. 2014. All Rights Reserved.
 *
 * moved from .com/dibs/assets/js/global/utils/commonjs/strings.js
 */

'use strict';

var $ = require('dibs-jquery-shim');

/**
 * decode html entities
 *
 * @param {String} string input with html entities
 * @returns {String} the string with html entities decoded into characters
 */
function decodeEntities(string) {
    return $('<div/>').html(string).text();
}

/**
 * get a value from a delimited string of key value pairs
 * *** note: all params must be regex safe - escaped if necessary
 *
 * @param {String} kv_string the full string to search (ie. 'login=n|pur=y|neg=y|pship=y')
 * @param {String} key the key to search for (ie. 'pur')
 * @param {String} set_delimiter the delimiter for each key/value set (ie. '\\|')
 * @param {String} [kv_delimiter] the delimiter for each key/value (ie. '=')
 * @returns {String|Boolean} the found value, false if not found
 */

function getFromDelimitedString(kv_string, key, set_delimiter, kv_delimiter) {
    kv_delimiter = kv_delimiter || '=';
    var pattern = new RegExp('' + key + kv_delimiter + '(.+?)(' + set_delimiter + '|$)');
    var found = pattern.exec(kv_string);
    if (found instanceof Array && found[1]) {
        return found[1];
    }
    return false;
}

/**
 * set a value in a delimited string of key value pairs
 * *** note: all params must be regex safe - escaped if necessary
 *
 * @param {String} kv_string the full string to search (ie. 'login=n|pur=y|neg=y|pship=y')
 * @param {String} key the key to search for (ie. 'pur')
 * @param {String} new_value the value to set for the passed in key (ie. 'y')
 * @param {String} set_delimiter the delimiter for each key/value set (ie. '\\|')
 * @param {String} [kv_delimiter] the delimiter for each key/value (ie. '=')
 * @returns {String} the kv_string with new_value replaced for key, or original kv_string if key was not found
 */

function setInDelimitedString(kv_string, key, new_value, set_delimiter, kv_delimiter) {
    kv_delimiter = kv_delimiter || '=';
    var old_value = this.getFromDelimitedString(kv_string, key, set_delimiter, kv_delimiter);
    if (old_value) {
        return kv_string.replace(key + kv_delimiter + old_value, key + kv_delimiter + new_value);
    }
    return kv_string;
}

function normalizeSpacing(str) {
    return $.trim(str).replace(/\s+/g, ' ');
}

function capitalize(str) {
    return typeof str === 'string' && str ? str.substring(0, 1).toUpperCase() + str.substring(1) : str;
}

function ord(string) {
    //  discuss at: http://phpjs.org/functions/ord/
    // original by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // bugfixed by: Onno Marsman
    // improved by: Brett Zamir (http://brett-zamir.me)
    //    input by: incidence
    //   example 1: ord('K');
    //   returns 1: 75
    //   example 2: ord('\uD800\uDC00'); // surrogate pair to create a single Unicode character
    //   returns 2: 65536

    var str = string + '';
    var code = str.charCodeAt(0);
    var hi = undefined;
    var low = undefined;

    if (code >= 0xD800 && code <= 0xDBFF) {
        // High surrogate (could change last hex to 0xDB7F to treat high private surrogates as single characters)
        hi = code;
        if (str.length === 1) {
            // This is just a high surrogate with no following low surrogate, so we return its value;
            return code;
            // we could also throw an error as it is not a complete character, but someone may want to know
        }
        low = str.charCodeAt(1);
        return (hi - 0xD800) * 0x400 + (low - 0xDC00) + 0x10000;
    }
    if (code >= 0xDC00 && code <= 0xDFFF) {
        // Low surrogate
        // This is just a low surrogate with no preceding high surrogate, so we return its value;
        return code;
        // we could also throw an error as it is not a complete character, but someone may want to know
    }
    return code;
}

/**
 * Behaves just like sprintf in C, Java, PHP, etc.
 * But only supports the string replacement (%s) functionality (i.e. no %d, %e, etc.)
 * @returns {string}
 */
function sprintf() {
    var args = Array.prototype.slice.call(arguments);
    return args.shift().replace(/%s/g, function () {
        return args.shift();
    });
}

/**
 * Clamps the string if it exceedes a given length of code units (not characters!)
 * and adds an ellipsis at the end.
 * @param  {String} str - String to clamp
 * @param  {Number} maxLength - Number of max code units, withouth ellipsis.
 * @return {String} - Clamped string with ellipsis attached
 */

function clampWithEllipsis(str, maxLength) {
    var ellipsis = String.fromCharCode(8230);
    if (str.length > maxLength) {
        return str.substring(0, maxLength - 1).trim() + ellipsis;
    }
    return str;
}
module.exports = {
    decodeEntities: decodeEntities,
    getFromDelimitedString: getFromDelimitedString,
    setInDelimitedString: setInDelimitedString,
    normalizeSpacing: normalizeSpacing,
    capitalize: capitalize,
    ord: ord,
    sprintf: sprintf,
    clampWithEllipsis: clampWithEllipsis
};


//////////////////
// WEBPACK FOOTER
// ./~/dibs-strings-helper/dist/index.js
// module id = 394
// module chunks = 64